import { useState } from "react";
import { motion } from "framer-motion";
import { User, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export const NameInputDialog = ({ isOpen, onSubmit, onClose }) => {
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name.trim());
      setName("");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-brown-surface border-brown-border max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-orbitron text-2xl text-gold flex items-center gap-2">
            <User className="w-6 h-6" />
            Save Your Score
          </DialogTitle>
          <DialogDescription className="font-poppins text-gold-light">
            Enter your name to record your victory on the leaderboard!
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <Input
            data-testid="player-name-input"
            type="text"
            placeholder="Enter your name..."
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={20}
            className="bg-brown-dark border-brown-border text-gold placeholder:text-gold/40 font-poppins focus:ring-gold focus:border-gold"
            autoFocus
          />

          <div className="flex gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 border-gold/50 text-gold hover:bg-gold/10 font-poppins"
            >
              Skip
            </Button>
            <Button
              data-testid="save-score-button"
              type="submit"
              disabled={!name.trim()}
              className="flex-1 bg-gold text-brown-dark hover:bg-gold/90 font-poppins font-bold disabled:opacity-50"
            >
              <Play className="w-4 h-4 mr-2" />
              Save
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default NameInputDialog;
